<template>
    <v-layout justify-center>
        <v-flex xs12 md12 lg9>
            <p style="padding-top:30px;">
                <v-card>
                    <v-container fluid
                                 grid-list-md>
                        <v-layout row wrap>
                            <v-flex v-for="card in cards"
                                    :key="card.title"
                                    v-bind="{ [card.class]: true }">
                                <v-card :to="card.href" class="home_tile">
                                    <v-img :src="card.src"
                                           height="200px"
                                           gradient="to top, rgba(100,115,115,.0), rgba(25,32,40,.9)"
                                           :alt="card.title">
                                        <v-container fill-height
                                                     fluid
                                                     pa-2>
                                            <v-layout fill-height>
                                                <v-flex xs12 align-end flexbox>
                                                    <span class="headline white--text" v-text="card.title"></span>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-img>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
                <v-card style="margin-top:10px">
                    <v-container>
                        <v-layout>
                            <v-flex xs12>
                                <span class="introText">The Parliamentary Handbook Online provides information on the parliamentary service and biographical details of current and former Senators and Members, and serves as a reference of all ministries, shadow ministries, parliamentary committees and electorates since Federation.</span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </p>
             <br />
        </v-flex>
    </v-layout>
   
</template>

<script>
    import API from '@/mixins/HandbookAPI'
    export default {
        data: () => API.RealProduction ? 
        //PROD
        ({
            cards: [
                {
                    title: 'Parliamentarians',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/Parliamentarians',
                    class: 'xs12 md6',
                },
                {
                    title: 'Prime Ministers',
                    src: 'https://www.aph.gov.au/~/media/DF7CB3BF2DBD4F2082B93A6489F1468F.ashx',
                    href: '/PrimeMinisters',
                    class: 'xs12 md6',
                },
                {
                    title: 'Ministries',
                    src: 'https://www.aph.gov.au/~/media/5A6D68B3A495495CBE8BA4014E5B0E1E.ashx',
                    href: '/Ministries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Shadow Ministries',
                    src: 'https://www.aph.gov.au/~/media/08CF7364D37E4099B29CA697126F0B17.ashx',
                    href: '/ShadowMinistries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Presidents',
                    src: 'https://www.aph.gov.au/~/media/E514FE8D822C48B9A02528C7314CDB34.ashx',
                    href: '/Presidents',
                    class: 'xs12 md6',
                },
                {
                    title: 'Speakers',
                    src: 'https://www.aph.gov.au/~/media/E49A4E07EEEC46219CEB7D03AA9E42A1.ashx',
                    href: '/Speakers',
                    class: 'sm12 md6',
                },
                {
                    title: 'Electorates',
                    src: 'https://www.aph.gov.au/~/media/99F8288C55C54AF99B42A9A26FEC094D.ashx',
                    href: '/Electorates',
                    class: 'xs12 md6',
                },
                {
                    title: 'Elections and By-Elections (Beta)',
                    src: 'https://www.aph.gov.au/~/media/8BFA09F35C344155A50BE591C09F0A0A.ashx',
                    href: '/Elections',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Committees',
                    src: 'https://www.aph.gov.au/~/media/E4B0C49BFCEB4354AA014A644D0313B1.ashx',
                    href: '/Committees',
                    class: 'sm12 md6',
                },
                {
                    title: 'Referendums',
                    src: 'https://www.aph.gov.au/~/media/FD2B794461384E9EA2F1BD2D36E1D503.ashx',
                    href: '/Referendums',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Royal Commissions',
                    src: 'https://www.aph.gov.au/~/media/4E06979D60874CC999FB6195760EA620.ashx',
                    href: '/RoyalCommissions',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Ministerial Statements',
                    src: 'https://www.aph.gov.au/~/media/A733291B0DE04CAB99BAD8F9321EBD5E.ashx',
                    href: '/MinisterialStatements',
                    class: 'xs12 md6',
                },
                {
                    title: 'Heads of State',
                    src: 'https://www.aph.gov.au/~/media/96EFDE0489F24678852348F8B542BB63.ashx',
                    href: '/HeadsOfState',
                    class: 'xs12 md6',
                },
                {
                    title: 'Parliamentary Office Holders',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/OfficeHolders',
                    class: 'sm12 md6',
                },
                {
                    title: 'Facts, Figures, and Timelines',
                    src: 'https://www.aph.gov.au/~/media/43664C3DFC744D1A995B7FD4FDF3620B.ashx',
                    href: '/StatisticalInformation',
                    class: 'xs12 md6',
                },
                {
                    title: 'Advanced Search',
                    src: 'https://www.aph.gov.au/~/media/E247C78E56D244D984A69CE50E4A6640.ashx',
                    href: '/AdvancedSearch',
                    class: 'sm12 md6',
                }
            ]
        }) 
        : (API.Production && !API.RealProduction ? 
        //DEV, TEST, not local and not PROD
        ({
            cards: [
                {
                    title: 'Parliamentarians',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/Parliamentarians',
                    class: 'xs12 md6',
                },
                {
                    title: 'Prime Ministers',
                    src: 'https://www.aph.gov.au/~/media/DF7CB3BF2DBD4F2082B93A6489F1468F.ashx',
                    href: '/PrimeMinisters',
                    class: 'xs12 md6',
                },
                {
                    title: 'Ministries',
                    src: 'https://www.aph.gov.au/~/media/5A6D68B3A495495CBE8BA4014E5B0E1E.ashx',
                    href: '/Ministries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Shadow Ministries',
                    src: 'https://www.aph.gov.au/~/media/08CF7364D37E4099B29CA697126F0B17.ashx',
                    href: '/ShadowMinistries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Presidents',
                    src: 'https://www.aph.gov.au/~/media/E514FE8D822C48B9A02528C7314CDB34.ashx',
                    href: '/Presidents',
                    class: 'xs12 md6',
                },
                {
                    title: 'Speakers',
                    src: 'https://www.aph.gov.au/~/media/E49A4E07EEEC46219CEB7D03AA9E42A1.ashx',
                    href: '/Speakers',
                    class: 'sm12 md6',
                },
                {
                    title: 'Electorates',
                    src: 'https://www.aph.gov.au/~/media/99F8288C55C54AF99B42A9A26FEC094D.ashx',
                    href: '/Electorates',
                    class: 'xs12 md6',
                },
                {
                    title: 'Elections and By-Elections (Beta)',
                    src: 'https://www.aph.gov.au/~/media/8BFA09F35C344155A50BE591C09F0A0A.ashx',
                    href: '/Elections',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Committees',
                    src: 'https://www.aph.gov.au/~/media/E4B0C49BFCEB4354AA014A644D0313B1.ashx',
                    href: '/Committees',
                    class: 'sm12 md6',
                },
                {
                    title: 'Referendums',
                    src: 'https://www.aph.gov.au/~/media/FD2B794461384E9EA2F1BD2D36E1D503.ashx',
                    href: '/Referendums',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Royal Commissions',
                    src: 'https://www.aph.gov.au/~/media/4E06979D60874CC999FB6195760EA620.ashx',
                    href: '/RoyalCommissions',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Ministerial Statements',
                    src: 'https://www.aph.gov.au/~/media/A733291B0DE04CAB99BAD8F9321EBD5E.ashx',
                    href: '/MinisterialStatements',
                    class: 'xs12 md6',
                },
                {
                    title: 'Heads of State',
                    src: 'https://www.aph.gov.au/~/media/96EFDE0489F24678852348F8B542BB63.ashx',
                    href: '/HeadsOfState',
                    class: 'xs12 md6',
                },
                {
                    title: 'Parliamentary Office Holders',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/OfficeHolders',
                    class: 'sm12 md6',
                },
                {
                    title: 'Facts, Figures, and Timelines',
                    src: 'https://www.aph.gov.au/~/media/43664C3DFC744D1A995B7FD4FDF3620B.ashx',
                    href: '/StatisticalInformation',
                    class: 'xs12 md6',
                },
                {
                    title: 'Advanced Search',
                    src: 'https://www.aph.gov.au/~/media/E247C78E56D244D984A69CE50E4A6640.ashx',
                    href: '/AdvancedSearch',
                    class: 'sm12 md6',
                },
            ]
        }) :
        //Local only
        ({
            //  important:  Card variables must not be dynamic
            cards: [
                {
                    title: 'Parliamentarians',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/Parliamentarians',
                    class: 'xs12 md6',
                },
                {
                    title: 'Prime Ministers',
                    src: 'https://www.aph.gov.au/~/media/DF7CB3BF2DBD4F2082B93A6489F1468F.ashx',
                    href: '/PrimeMinisters',
                    class: 'xs12 md6',
                },
                {
                    title: 'Ministries',
                    src: 'https://www.aph.gov.au/~/media/5A6D68B3A495495CBE8BA4014E5B0E1E.ashx',
                    href: '/Ministries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Shadow Ministries',
                    src: 'https://www.aph.gov.au/~/media/08CF7364D37E4099B29CA697126F0B17.ashx',
                    href: '/ShadowMinistries',
                    class: 'xs12 md6',
                },
                {
                    title: 'Presidents',
                    src: 'https://www.aph.gov.au/~/media/E514FE8D822C48B9A02528C7314CDB34.ashx',
                    href: '/Presidents',
                    class: 'xs12 md6',
                },
                {
                    title: 'Speakers',
                    src: 'https://www.aph.gov.au/~/media/E49A4E07EEEC46219CEB7D03AA9E42A1.ashx',
                    href: '/Speakers',
                    class: 'sm12 md6',
                },
                {
                    title: 'Electorates',
                    src: 'https://www.aph.gov.au/~/media/99F8288C55C54AF99B42A9A26FEC094D.ashx',
                    href: '/Electorates',
                    class: 'xs12 md6',
                },
                {
                    title: 'Elections and By-Elections (Beta)',
                    src: 'https://www.aph.gov.au/~/media/8BFA09F35C344155A50BE591C09F0A0A.ashx',
                    href: '/Elections',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Committees',
                    src: 'https://www.aph.gov.au/~/media/E4B0C49BFCEB4354AA014A644D0313B1.ashx',
                    href: '/Committees',
                    class: 'sm12 md6',
                },
                {
                    title: 'Referendums',
                    src: 'https://www.aph.gov.au/~/media/FD2B794461384E9EA2F1BD2D36E1D503.ashx',
                    href: '/Referendums',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Royal Commissions',
                    src: 'https://www.aph.gov.au/~/media/4E06979D60874CC999FB6195760EA620.ashx',
                    href: '/RoyalCommissions',
                    class: 'xs12 md6',
                }, 
                {
                    title: 'Ministerial Statements',
                    src: 'https://www.aph.gov.au/~/media/A733291B0DE04CAB99BAD8F9321EBD5E.ashx',
                    href: '/MinisterialStatements',
                    class: 'xs12 md6',
                },
                {
                    title: 'Heads of State',
                    src: 'https://www.aph.gov.au/~/media/96EFDE0489F24678852348F8B542BB63.ashx',
                    href: '/HeadsOfState',
                    class: 'xs12 md6',
                },
                {
                    title: 'Parliamentary Office Holders',
                    src: 'https://www.aph.gov.au/~/media/1C1FD2F6B3C544CC88FDEB2F9BA7E068.ashx',
                    href: '/OfficeHolders',
                    class: 'sm12 md6',
                },
                {
                    title: 'Facts, Figures, and Timelines',
                    src: 'https://www.aph.gov.au/~/media/43664C3DFC744D1A995B7FD4FDF3620B.ashx',
                    href: '/StatisticalInformation',
                    class: 'xs12 md6',
                },
                {
                    title: 'Advanced Search',
                    src: 'https://www.aph.gov.au/~/media/E247C78E56D244D984A69CE50E4A6640.ashx',
                    href: '/AdvancedSearch',
                    class: 'sm12 md6',
                },
            ]
        }))
    }
</script>
<style scoped  lang="stylus">
    .introText {
        font-style: italic;
        font-size: 11pt;
    }
    .home_tile >>> .v-image__image--cover{
            transition: all .3s ease-out;
    }
    .home_tile:hover >>> .v-image__image--cover, .home_tile:focus-visible >>> .v-image__image--cover{
        transform: scale3d(1.05,1.05,1);
    }
    a.home_tile:focus-visible {
        outline: 3px solid #309fd5;
    }
</style>
